// Srinagar location images
// Automatically import all images from the srinagar folder
// For now, use fallback images until actual srinagar images are added
// import fallbackEvents from "../fallback/events.jpg";
// import fallbackFacilities from "../fallback/facilities.jpg";

// When you add actual srinagar images, uncomment this code:

const srinagarImages = require.context(
  "./",
  false,
  /\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/i
);

const images = srinagarImages
  .keys()
  .map((key) => srinagarImages(key))
  .sort((a, b) => {
    const nameA = a.split("/").pop().split(".")[0];
    const nameB = b.split("/").pop().split(".")[0];
    return nameA.localeCompare(nameB, undefined, { numeric: true });
  });

// For now, use fallback images
// const images = [fallbackEvents, fallbackFacilities];

export default images;
